export default {
	LOG_LEVEL: 'info',
	IDM_CLIENT_ID: 'internalMarketingTools',
	ID_GATEWAY_URL: 'https://idgatewayawsqa.flqa.net',
	ORG_SERVICE_URL: 'https://ecsandproxyawsqa.flqa.net',
};
